import { Grid, Typography, useTheme } from '@mui/material';
import _map from 'lodash/map';
import { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import CardCryptoPayment from './CardCryptoPayment';
import HeaderStep, { ButtonData } from './HeaderStep';
import { useNavigate } from 'react-router-dom';

interface Steps {
    step: number;
    title: string;
    description: string;
}
const steps: Steps[] = [
    {
        step: 1,
        title: 'creating-the-checkout',
        description: 'creating-the-checkout-description'
    },
    {
        step: 2,
        title: 'integrating-the-checkout',
        description: 'integrating-the-checkout-description'
    }
];

const StepCryptoPayment = () => {
    const theme = useTheme();
    const navigate = useNavigate();

    const handleStartNow = () => {
        navigate('/merchant/invoices-list');
    };

    const handleHowItWorks = () => {
        window.open('https://xaigate.gitbook.io/api-docs', '_blank');
    };

    const buttons = useMemo<ButtonData[]>(
        () => [
            { id: 1, title: 'start-now', onClick: handleStartNow },
            { id: 2, title: 'how-it-works', onClick: handleHowItWorks }
        ],
        [handleStartNow, handleHowItWorks]
    );

    return (
        <Grid container flexDirection="column" gap={1}>
            <Grid item xs={12}>
                <HeaderStep title="step-crypto-payment-title" buttons={buttons} />
            </Grid>
            <Grid item xs={12}>
                <Typography variant="body1">
                    <FormattedMessage id="step-crypto-payment-description" />
                </Typography>
            </Grid>
            <Grid item xs={12}>
                <Grid container sx={{ flexWrap: { xs: 'wrap', md: 'nowrap' } }} gap={2}>
                    {_map(steps, (step) => (
                        <Grid item key={step.step} xs={12} md={6}>
                            <CardCryptoPayment
                                {...step}
                                childrenIcon={
                                    <Typography variant="h3" sx={{ color: theme.palette.text.hint }}>
                                        {step.step}
                                    </Typography>
                                }
                            />
                        </Grid>
                    ))}
                </Grid>
            </Grid>
        </Grid>
    );
};

export default StepCryptoPayment;
